export default {
  turno: {},
  turnos: [],
  fields: {},
  errorArray: [],
  dialog: false,
  nuevo: false,
  actualizado: false,
};
